import React from 'react';

const Footer = () => {
    return (
        <div className="py-12">
           
            <div className="flex justify-between border-t-2 border-gray-600 py-6">
                <div className="">
                    
                    <h1 className=' '>L_January 2023</h1>
                    <h1 className=' '>C_💕Mozahidul Islam💕</h1>
                    <h1 className=' '>Programmer || Problem solver  </h1>
                   
                </div>
                <div className="">
                    <h1 className='text-center '>Version Alone 2.0</h1>
                </div>
            </div>
        </div>
    );
};
 
export default Footer;